<template>
  <div>
    <ValidationObserver ref="observer">
      <div class="mt-5 vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-5">
            <li>
              <router-link
                :to="{ path: '/setup/automation-master' }"
                class="vx-row"
              >
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
                <h4>{{ $t("setup.label.edit_automation") }}</h4>
              </router-link>
            </li>
          </ul>
        </div>
        <vx-card title no-shadow card-border>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.EntityName')"
              >
                <vs-input
                  :label="$t('setup.label.EntityName')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="entityName"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.EntityType") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.EntityType')"
                >
                  <v-select
                    v-model="entityType"
                    :options="entityTypeOptions"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full mb-2"
                    :reduce="(obj) => obj"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full mb-2">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.WorkflowName')"
              >
                <vs-input
                  :label="$t('setup.label.WorkflowName')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="workflowName"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full mb-2">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Description')"
              >
                <vs-input
                  :label="$t('setup.label.Description')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="description"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full mb-2">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('customers.label.sub_category')"
              >
                <vs-input
                  :label="$t('customers.label.sub_category')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="subCategoryId"
                  readonly
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('setup.label.Priority')"
              >
                <vs-input
                  :label="$t('setup.label.Priority')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="priority"
                  readonly
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.region") }}
                  <span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.region')"
                >
                  <v-select
                    label="cityName"
                    :options="
                      automationTemplate && automationTemplate.cityDetailsData
                    "
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :reduce="(obj) => obj.id"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    v-model="areaId"
                    class="min-w-200 w-full mb-2"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button class="mr-3 mb-2 footerButton-next" @click="onSubmit">{{
            $t("setup.label.Submit")
          }}</vs-button>
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";

export default {
  data() {
    return {
      entityName: "",
      entityType: "",
      subCategoryId: "",
      category: "",
      priority: "",
      areaId: "",
      serviceId: "",
      workflowName: "",
      description: "",
      entityTypeOptions: ["Group", "Individual"],
      errorMessage: "",
      warningPopup: false,
      warningText: "",
    };
  },
  components: {
    "v-select": vSelect,
    ValidationProvider,
    ValidationObserver,
  },

  computed: {
    ...mapState({
      automationTemplate: (state) => state.automationMaster.automationTemplate,
      automationMasterById: (state) =>
        state.automationMaster.automationMasterById,
      subCategoryItem: (state) => state.entity.ticketSubcategory,
    }),
  },
  methods: {
    async getAutomationMasterTemplateMethod() {
      try {
        await this.$store.dispatch(
          "automationMaster/getAutomationMasterTemplateAction"
        );
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
    async getAutomationMasterByIdMethod() {
      try {
        await this.$store.dispatch(
          "automationMaster/getAutomationMasterByIdAction",
          this.$route.params.id
        );
        this.entityName = this.automationMasterById.entityName || "";
        this.entityType = this.automationMasterById.entityType || "";
        this.subCategoryId = this.automationMasterById.subcategory || "";
        this.priority = this.automationMasterById.priority || "";
        this.areaId = this.automationMasterById.areaId || "";
        this.workflowName = this.automationMasterById.workflowName || "";
        this.description = this.automationMasterById.description;
      } catch (e) {
        this.$toasted.error(e.message, {
          duration: 2000,
        });
      }
    },
    async onSubmit() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      const ServiceId =
        this.automationTemplate &&
        this.automationTemplate.serviceData &&
        this.automationTemplate.serviceData[0]
          ? this.automationTemplate.serviceData[0].id
          : "";
      let payload = {
        id: this.$route.params.id,
        data: {
          entityName: this.entityName,
          entityType: this.entityType,
          priority: this.priority,
          areaId: this.areaId,
          serviceId: ServiceId,
          workflowName: this.workflowName,
          description: this.description,
        },
      };
      try {
        await this.$store.dispatch(
          "automationMaster/updateAutomationMasterAction",
          payload
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Automation Updated Successfully!",
          type: "success",
        });
        this.cancel();
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    async getSubCategory(categoryId) {
      this.subCategoryId = null;
      try {
        if (categoryId) {
          this.$store.dispatch("entity/setTicketSubcategory", categoryId);
        } else {
          this.$store.commit("entity/SET_TICKET_SUBCATEGORY", []);
          this.subCategoryId = null;
        }
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    setPriority(selectedSubCategory) {
      const subCategoryObj = this.subCategoryItem.find(
        (item) => item.id === selectedSubCategory
      );
      this.priority = subCategoryObj.priority;
    },
    cancel() {
      this.$router.push({ path: "/setup/automation-master" });
    },
  },

  async mounted() {
    await this.getAutomationMasterTemplateMethod();
    await this.getAutomationMasterByIdMethod();
  },
};
</script>
